import React from "/vendor/react";

import { EditIcon } from "/lib/component/icon";
import MenuItem from "./MenuItem";

const Edit = props => <MenuItem {...props} />;

Edit.displayName = "ToolbarMenuItems.Edit";

Edit.defaultProps = {
  title: "Edit…",
  titleCondensed: "Edit",
  description: "Edit resource configuration.",
  icon: <EditIcon />,
};

export default Edit;
